import { Box } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

import { HeroImpeccable } from '#features/landing/components/Landing/HeroImpeccable';

/** Isolated first-screen experiment; it does not depend on landing API data. */
export const Route = createFileRoute('/{-$locale}/_layout/preview/landing-impeccable')({
  staticData: { rendersOwnFooter: true },
  component: LandingImpeccable,
});

function LandingImpeccable() {
  return (
    <Box w="100%" bg="bg" borderBottom="1px solid" borderColor="border.subtle">
      <Box maxW="1200px" mx="auto" px={{ base: 4, md: 6, lg: 8 }}>
        <HeroImpeccable image="/preview/landing-impeccable.webp" />
      </Box>
    </Box>
  );
}
